import { useCallback } from 'react';
import { flex } from 'styles/utils';
import { Row, Col } from 'components/Grid';
import { css, cx } from '@linaria/core';
import { ListGridToggle } from 'modules/Listings/components/ListGridToggle/ListGridToggle';
import { CommunitySearchMenu } from 'components/CommunitySearchMenu';
import { ENTITY_SLUGS } from 'modules/Listings/store/StateContext';
import { IconCloseSquareDark, IconFilterTwo } from 'components/Icons';
import { Button } from 'components/Button';
import { Button as NewButton } from 'components/ui_library/Button';
interface NavBarProps {
  activeTab: string;
  onOptionSelected: (tab: string) => void;
  isFiltersOpen: boolean;
  toggleFilterState: (isFiltersOpen: boolean) => void;
  onClose?: () => unknown;
}
export const NavBar = ({
  activeTab,
  onOptionSelected,
  isFiltersOpen,
  toggleFilterState,
  onClose
}: NavBarProps): JSX.Element => {
  const handleModelsSelected = useCallback(() => onOptionSelected(ENTITY_SLUGS.models), []);
  const handleWorkflowsSelected = useCallback(() => onOptionSelected(ENTITY_SLUGS.workflows), []);
  const isModelsSelected = activeTab === ENTITY_SLUGS.models;
  const isWorkflowsSelected = activeTab === ENTITY_SLUGS.workflows;
  const onFilterToggle = useCallback(() => {
    toggleFilterState(!isFiltersOpen);
  }, [isFiltersOpen]);
  return <nav>
      <Row className={NavBarStyles}>
        <Col>
          <ul className={cx(flex.init)}>
            <NewButton variant={isModelsSelected ? 'secondary' : 'unstyled'} tabIndex={0} onKeyPress={handleModelsSelected} onClick={handleModelsSelected}>
              Models
            </NewButton>

            <NewButton variant={isWorkflowsSelected ? 'secondary' : 'unstyled'} tabIndex={0} onKeyPress={handleWorkflowsSelected} onClick={handleWorkflowsSelected}>
              Workflows
            </NewButton>
          </ul>
        </Col>
        <Col>
          <div className="close-button">
            {onClose ? <Button variant="tertiary" size="md" onClick={onClose}>
                <IconCloseSquareDark size={20} color="#101828" />
              </Button> : null}
          </div>
        </Col>
      </Row>
      <Row>
        <div className={toolBar}>
          {activeTab === ENTITY_SLUGS.models && isFiltersOpen && <NewButton className={cx(filterToggle, isFiltersOpen && 'selected')} variant="unstyled" onClick={onFilterToggle}>
              <IconFilterTwo color="#195AFF" size={20} /> Filters
            </NewButton>}
          <CommunitySearchMenu />
          <ListGridToggle />
        </div>
      </Row>
    </nav>;
};
const NavBarStyles = "omponents__CommunitySearchModal__components__NavBar_tsx-NavBarStyles-n51kz8k";
const toolBar = cx(flex.init, flex.alignItems.center, flex.justifyContent.end, "omponents__CommunitySearchModal__components__NavBar_tsx-toolBar-t1aj81mh");
const filterToggle = "omponents__CommunitySearchModal__components__NavBar_tsx-filterToggle-fwjj324";

require("./NavBar.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./NavBar.tsx");